import { mapActions, mapGetters } from 'vuex';


/**
 * Helper mixin that checks if the user is connected with Xero.'
 * This guard is made as a mixin because we need to fetch data before checking.
 * Therefore, this can't be on the router level.
 */
export default {
  computed: {
    ...mapGetters('entities/users', ['isDistributorXeroConnected']),
  },
  methods: {
    ...mapActions('entities/users', ['initDistributorLoggedUser']),
  },
  async created() {
    await this.initDistributorLoggedUser();
    if (!this.isDistributorXeroConnected) {
      this.$router.replace({
        name: 'distributor-xero-not-connected',
        params: {
          flash: {
            title: 'You are not connected to Xero.',
            type: 'fail',
          },
        },
      });
    }
  },
};
